import { injectable } from 'tsyringe';
import { createElement } from '@gn-audio/core/common/templating';
import { UipTranslationService } from '@/Feature/Uip/platform/app/services';
import { getAuthBearerValue, isSiteFeatureEnabled } from '@gn-audio/core/common/utilities';
import { IUipTranslation, IUipMenuItem } from '@/Feature/Uip/platform/app/models';
import { ISFCCSetting } from '@gn-audio/core/api/site-settings/models/sfcc-setting';
import { fetchSFCCSetting } from '@gn-audio/core/api/site-settings/fetch-sfcc-setting';
import { SiteFeature } from '@gn-audio/core/api/site-settings/enums';
import { SFCCTokenService } from '@gn-audio/sfcc-basket/services';

import './uip-menu-item-order-history.component.scss';

import template from './uip-menu-item-order-history.component.html';

@injectable()
export class UipMenuItemOrderHistoryComponent implements IUipMenuItem {
  private element?: Element;
  private form?: HTMLFormElement;

  constructor(
    private readonly translationService: UipTranslationService,
    private readonly tokenService: SFCCTokenService,
  ) { }

  public destroy() {
    this.element?.removeEventListener('click', this.onOrderHistory);
    this.element?.remove();
  }

  public async render(container: Element) {
    const settings: ISFCCSetting | null = await fetchSFCCSetting();
    const translations: IUipTranslation = await this.translationService.translations;
    this.element = createElement(template, settings, translations);
    this.element.addEventListener('click', this.onOrderHistory);
    container.appendChild(this.element);
    this.form = this.element.querySelector('.order-history-form');
  }

  public async shouldRender() {
    return !(await isSiteFeatureEnabled(SiteFeature.TopMenuMyJabraEnabled));
  }

  private onOrderHistory = async (event: MouseEvent) => {
    event.preventDefault();
    const tokenInput: HTMLInputElement = this.form.querySelector('input[name="token"]');
    tokenInput.value = getAuthBearerValue(await this.tokenService.ensure());
    this.form.submit();
  };
}
